import React from 'react';
import { motion } from 'framer-motion';
import { Check, X } from 'lucide-react';
export function ForWhoSection() {
  const forWho = ['US Homeowners who have seen their mortgage payment jump this year.', 'Individuals 50+ looking to protect their home equity and retirement savings.', "Homeowners who know their property needs repairs and isn't worth the County's 'perfect condition' estimate.", 'Anyone tired of giving the government extra money due to calculation errors.'];
  const notForWho = ['Investors of large commercial or industrial complexes.', 'Renters (this guide is exclusively for property owners).', 'Anyone looking to illegally evade taxes (you will learn to pay what is fair, not to evade).'];
  return <section className="bg-cream py-20 px-4 md:px-8" data-id="element-46">
      <div className="max-w-6xl mx-auto" data-id="element-47">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-48">
          {/* Who this IS for */}
          <motion.div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border-t-8 border-green" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} data-id="element-49">
            <h3 className="text-3xl font-bold text-charcoal mb-8" data-id="element-50">
              Who This Is For
            </h3>
            <ul className="space-y-6" data-id="element-51">
              {forWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-52">
                  <div className="bg-green/10 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-53">
                    <Check className="w-5 h-5 text-green" data-id="element-54" />
                  </div>
                  <span className="text-lg text-gray-700 leading-relaxed" data-id="element-55">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>

          {/* Who this is NOT for */}
          <motion.div className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border-t-8 border-red" initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2,
          duration: 0.6
        }} data-id="element-56">
            <h3 className="text-3xl font-bold text-charcoal mb-8" data-id="element-57">
              Who This Is NOT For
            </h3>
            <ul className="space-y-6" data-id="element-58">
              {notForWho.map((item, i) => <li key={i} className="flex items-start gap-4" data-id="element-59">
                  <div className="bg-red/10 p-1 rounded-full flex-shrink-0 mt-1" data-id="element-60">
                    <X className="w-5 h-5 text-red" data-id="element-61" />
                  </div>
                  <span className="text-lg text-gray-700 leading-relaxed" data-id="element-62">
                    {item}
                  </span>
                </li>)}
            </ul>
          </motion.div>
        </div>
      </div>
    </section>;
}